var _circle, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#3B82F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2127 12C18.2127 15.3137 15.4788 18 12.1064 18C8.73391 18 6 15.3137 6 12C6 8.68629 8.73391 6 12.1064 6C15.4788 6 18.2127 8.68629 18.2127 12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0501 8.67C12.0501 8.45 12.1268 8.26333 12.2801 8.11C12.4334 7.95 12.6201 7.87 12.8401 7.87C13.0601 7.87 13.2468 7.95 13.4001 8.11C13.5601 8.26333 13.6401 8.45 13.6401 8.67C13.6401 8.89 13.5601 9.07666 13.4001 9.23C13.2468 9.38333 13.0601 9.46 12.8401 9.46C12.6201 9.46 12.4334 9.38333 12.2801 9.23C12.1268 9.07666 12.0501 8.89 12.0501 8.67ZM13.2901 10L12.5701 13.4C12.5434 13.5133 12.5301 13.62 12.5301 13.72C12.5301 13.86 12.5634 13.9567 12.6301 14.01C12.6968 14.0633 12.8001 14.09 12.9401 14.09C13.0334 14.09 13.1001 14.0833 13.1401 14.07C13.1868 14.0567 13.2268 14.0433 13.2601 14.03C13.2468 14.21 13.2068 14.3633 13.1401 14.49C13.0734 14.6167 12.9901 14.7233 12.8901 14.81C12.7901 14.8967 12.6768 14.96 12.5501 15C12.4234 15.04 12.2934 15.06 12.1601 15.06C11.8601 15.06 11.6068 14.9667 11.4001 14.78C11.1934 14.5867 11.0901 14.28 11.0901 13.86C11.0901 13.68 11.1168 13.4633 11.1701 13.21L11.8501 10H13.2901Z",
    fill: "#3B82F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.9ced5d03.svg";
export { ForwardRef as ReactComponent };